import * as React from 'react';
import { formatCurrency } from '../../../CurrencyUtils';
class FormattedCurrency extends React.Component {
    constructor(props) {
        super(props);
        this._isMounted = false;
        this._handleFormattedValue = this._onFormattedValue.bind(this);
        this.state = Object.assign({}, this.state, {
            formattedValue: ''
        });
        if (props) {
            this.componentWillReceiveProps(props);
        }
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentWillReceiveProps(nextProps) {
        const { formatFunc, val, currency, options } = nextProps;
        if (formatFunc) {
            formatFunc(val, currency, options, this._handleFormattedValue);
        }
        else {
            this._formatValue(val, currency, options);
        }
    }
    render() {
        const { val, sensitiveValue } = this.props;
        const { formattedValue } = this.state;
        return (React.createElement("span", { "data-mf-replace-inner": sensitiveValue ? '***' : undefined }, formattedValue || val));
    }
    _onFormattedValue(formattedValue) {
        const newState = { formattedValue };
        if (this._isMounted) {
            this.setState(newState);
        }
        else {
            this.state = Object.assign({}, this.state, newState);
        }
    }
    _formatValue(val, currency, options) {
        this._onFormattedValue(formatCurrency(val, currency, options));
    }
}
export { FormattedCurrency };
export default FormattedCurrency;
